import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemePatchService {
  private observer: MutationObserver | null = null;
  private currentTheme = 'light';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  setTheme(theme: string) {
    this.currentTheme = theme;
    this.patchAllModals();
    this.observeModalMutation();
  }

  private patchAllModals() {
    const modals = this.document.querySelectorAll(
      '.ant-modal, .ant-popover, .ant-drawer'
    );
    modals.forEach((el) => {
      (el as HTMLElement).setAttribute('data-theme', this.currentTheme);
    });
  }

  private observeModalMutation() {
    if (this.observer) return; // Chỉ khởi tạo 1 lần

    this.observer = new MutationObserver(() => this.patchAllModals());
    this.observer.observe(this.document.body, {
      childList: true,
      subtree: true,
    });
  }
}
